import { Box, Typography } from "@mui/material";
import { useCoreApi } from "providers/CoreApiProvider";
import React from "react";
import { useTranslation } from "react-i18next";
import { BaseTrainingSelectorDrawer, TrainingSelectorFilterOptions, TrainingSelectorProps } from "views/lms/training/drawers/BaseTrainingSelectorDrawer";

////////////////////////////////////////////////////////////////////////////////

interface IProps extends TrainingSelectorProps {
    exceptTrainingId?: string;
    onlyManage?: boolean;
}

////////////////////////////////////////////////////////////////////////////////

export const TrainingSelectorDrawer: React.FC<IProps> = (props) => {
    const api = useCoreApi();
    const { t } = useTranslation("lms");
    const { exceptTrainingId, trainingType, onlyManage = false } = props;

    const handleGetdata = ({ signal, ...filter }: TrainingSelectorFilterOptions) => {
        return api.v1.lmsSelectors.training({
            exceptTrainingId: exceptTrainingId ?? null,
            trainingType: trainingType ?? null,
            onlyManage: onlyManage,
            ...filter,
        }, { signal: signal });
    };

    return <BaseTrainingSelectorDrawer
        {...props}
        onGetData={handleGetdata}
        contentHeader={
            (props) => props.searchText == ""
                ? <Box mt={1}><Typography variant="subtitle1">{t("Selectors.Training.ShowingMoreRecent")}</Typography></Box>
                : undefined
        }

    />;
};
